import React, { useEffect, useState } from "react";
import {
  aboutRestroomIcon,
  featuresAvIcon,
  featuresChairsIcon,
  featuresKichensIcon,
  featuresMicIcon,
  featuresOutdoorAreaIcon,
  featuresRestRooms,
  featuresSoundproofIcon,
  featuresSpeakersIcon,
  featuresTablesIcon,
  featuresTransportIcon,
  featuresWheelchairIcon,
  featuresWifiIcon,
} from "../../Constants/Images";
import { SpaceTypes } from "../../Constants/Interfaces";

interface FeaturesTabType {
  item: SpaceTypes;
}
interface TagsType {
  id: string;
  text: string;
  type: string;
}

const FeaturesTab: React.FC<FeaturesTabType> = ({ item }) => {
  const [featuresTags, setFeaturesTags] = useState<TagsType[] | []>([]);
  const [amenitiesTags, setAmenitiesTags] = useState<TagsType[] | []>([]);
  const [otherTags, setOtherTags] = useState<TagsType[] | []>([]);

  useEffect(() => {
    if (item?.features && item.features.length > 0) {
      const featuresItems = item.features || [];
      setFeaturesTags(featuresItems);
    }
    if (item?.amenities && item.amenities.length > 0) {
      setAmenitiesTags(item.amenities);
    }
    if (item && item?.other && item.other.length > 0) {
      setOtherTags(item.other);
    }
  }, []);

  return (
    <div className="features-content-wrapper">
      <h2>Included in your booking</h2>

      {featuresTags && featuresTags?.length > 0 && (
        <div className="features-list-wrapper">
          <h4>Features</h4>

          <ul>
            {featuresTags?.map((item, index) => (
              <li key={`tag-${item.id}`}>
                {/* <img src={featuresOutdoorAreaIcon} alt="" /> */}
                {item.text}
              </li>
            ))}
          </ul>
        </div>
      )}

      {amenitiesTags && amenitiesTags?.length > 0 && (
        <div className="features-list-wrapper">
          <h4>Amenities</h4>

          <ul>
            {amenitiesTags?.map((item, index) => (
              <li key={`tag-${item.id}`}>
                {/* <img src={featuresOutdoorAreaIcon} alt="" /> */}
                {item.text}
              </li>
            ))}
          </ul>
        </div>
      )}

      {otherTags && otherTags?.length > 0 && (
        <div className="features-list-wrapper">
          <h4>Other</h4>

          <ul>
            {otherTags?.map((item, index) => (
              <li key={`tag-${item.id}`}>
                {/* <img src={featuresOutdoorAreaIcon} alt="" /> */}
                {item.text}
              </li>
            ))}
          </ul>
        </div>
      )}

      {/* <div className="features-list-wrapper">
        <h4>Amenities</h4>

        <ul>
          <li>
            <img src={featuresTablesIcon} alt="" /> Tables
          </li>
          <li>
            <img src={featuresChairsIcon} alt="" /> Chairs
          </li>
          <li>
            <img src={featuresSpeakersIcon} alt="" /> Speakers
          </li>
          <li>
            <img src={featuresMicIcon} alt="" /> Mics
          </li>
          <li>
            <img src={featuresWifiIcon} alt="" /> WiFi
          </li>
        </ul>
      </div>

      <div className="features-list-wrapper">
        <h4>Other</h4>

        <ul>
          <li>ADA Restrooms</li>
          <li>Misc Activities</li>
          <li>Dance Floor</li>
          <li>Soft Seating</li>
          <li>Cups Glasses</li>
        </ul>
      </div> */}

      <div className="no-amenity-info">
        <p>
          Don't see an amenity you're looking for?{" "}
          <span className="" onClick={() => {}}>
            Ask the Host, {item?.user?.name}
          </span>
        </p>
      </div>
    </div>
  );
};

export default FeaturesTab;
